import React from 'react';
import './App.css';
import { Tasks } from './features/tasks/Tasks';

function App() {
  return (
    <div className="App">
    <h3>challenge test - programmer : Yasin Asadnezhad</h3>  
 
     <Tasks />
 </div>
  );
}

export default App;
